(function () {
  /* LEVANRA custom product-page JS (women's-wear pivot).
     ============================================================
     PER-PRODUCT CONFIG, keyed by product handle (read from the URL).
     Each product's PDP renders from its own entry below, so the two
     pages are independent. Add a new product = add a handle entry. The
     fallback (if a handle isn't listed) is the V-neck config.
     ============================================================ */

  function lvProductHandle() {
    var parts = (location.pathname || '').split('/').filter(Boolean);
    var i = parts.indexOf('products');
    return (i !== -1 && parts[i + 1]) ? decodeURIComponent(parts[i + 1]).toLowerCase() : '';
  }

  var PRODUCT_CONFIGS = {
    'cozy-v-neck-perfect-1-4-zip': {
      rating: 4.8,
      count: 62,
      breadcrumb: [
        { label: 'WOMENS', href: '/collections/all' },
        { label: 'SWEATERS & CARDIGANS', href: '/collections/all' }
      ],
      offer: '2 items for $97',
      /* Admin price is the FULL price ($89). salePrice = the single-item deal price
         ($89 - $30). PDP shows the admin price struck + this in red + a SALE badge.
         Keep this in sync with the "1 item deal" discount in Shopify admin. */
      salePrice: '$59.00',
      sizeGuide: {
        title: "Women's Tops (US)",
        fitLine: '<strong>Oversized fit</strong>',
        bullets: ['Size down for a classic fit.', 'Hits below waist.'],
        columns: ['Size (US)', 'Numeric Size (US)', 'Bust', 'Natural Waist', 'Length'],
        /* row = [sizeLabel, numericSize, ...measurement cells]. Cells from index 2
           on are inch values that the IN/CM toggle converts. */
        rows: [
          ['S', '4 - 6', '40', '26.5 - 28', '26.6'],
          ['M', '8 - 10', '42', '28.5 - 30', '27.2'],
          ['L', '12 - 14', '44', '31 - 32.5', '27.8'],
          ['XL', '16 - 18', '46.5', '34 - 35.5', '28.3'],
          ['XXL', '20', '49', '37 - 38.5', '28.9']
        ]
      }
    },

    'lightweight-open-front-cardigan': {
      /* PLACEHOLDER -- copied from the V-neck so the page works immediately.
         Replace rating/count/offer/sizeGuide with the cardigan's real values. */
      rating: 4.8,
      count: 62,
      breadcrumb: [
        { label: 'WOMENS', href: '/collections/all' },
        { label: 'SWEATERS & CARDIGANS', href: '/collections/all' }
      ],
      offer: '2 items for $97',
      sizeGuide: {
        title: "Women's Tops (US)",
        fitLine: 'Fits <strong>true to size</strong>',
        bullets: ['Size down for a tinier fit.', 'Hits below waist.'],
        columns: ['Size (US)', 'Numeric Size (US)', 'Bust', 'Natural Waist', 'Length'],
        rows: [
          ['S', '4 - 6', '40', '26.5 - 28', '26.6'],
          ['M', '8 - 10', '42', '28.5 - 30', '27.2'],
          ['L', '12 - 14', '44', '31 - 32.5', '27.8'],
          ['XL', '16 - 18', '46.5', '34 - 35.5', '28.3']
        ]
      }
    }
  };

  var LV_CFG = PRODUCT_CONFIGS[lvProductHandle()] || PRODUCT_CONFIGS['cozy-v-neck-perfect-1-4-zip'];

  var RATING = LV_CFG.rating;
  var COUNT = LV_CFG.count;
  var BREADCRUMB_ITEMS = LV_CFG.breadcrumb;

  function insertRatingBadge() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.lv-rating-badge')) return;
    var anchor = info.querySelector('.lv-title-price') || info.querySelector('.product__title');
    if (!anchor) return;
    var pct = (RATING / 5) * 100;
    var stars = '★★★★★';
    var badge = document.createElement('div');
    badge.className = 'lv-rating-badge';
    badge.innerHTML =
      '<span class="lv-rating-stars">' +
        '<span class="lv-rating-stars__empty">' + stars + '</span>' +
        '<span class="lv-rating-stars__filled" style="width:' + pct + '%">' + stars + '</span>' +
      '</span>' +
      '<span class="lv-rating-count">' + RATING + ' (' + COUNT + ' Reviews)</span>';
    anchor.insertAdjacentElement('beforebegin', badge);
  }

  function insertBreadcrumb() {
    if (document.querySelector('.lv-breadcrumb')) return;
    if (!document.querySelector('.product__info-container')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var bar = document.createElement('nav');
    bar.className = 'lv-breadcrumb';
    bar.setAttribute('aria-label', 'Breadcrumb');
    var inner = document.createElement('div');
    inner.className = 'lv-breadcrumb__inner page-width';
    var parts = BREADCRUMB_ITEMS.map(function (it, i) {
      var link = '<a href="' + it.href + '">' + it.label + '</a>';
      return (i === 0 ? '' : '<span class="lv-breadcrumb__sep">/</span>') + link;
    });
    inner.innerHTML = parts.join('');
    bar.appendChild(inner);
    main.insertBefore(bar, main.firstChild);
  }

  function scrollToBuySection() {
    var target =
      document.querySelector('.product__info-container') ||
      document.querySelector('.lv-title-price') ||
      document.querySelector('.product__title');
    if (!target) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var peek = Math.round(window.innerHeight * 0.12); /* ~12% gallery peek */
    var y = target.getBoundingClientRect().top + window.pageYOffset - peek;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  var stickyBar = null;
  var stickyObserver = null;
  var stickyObservedBtn = null;

  function updateSticky() {
    if (!stickyBar) return;
    var btn = document.querySelector('.product-form__submit');
    if (!btn || !btn.isConnected) { stickyBar.classList.remove('is-visible'); return; }
    var rect = btn.getBoundingClientRect();
    var scrolledPast = rect.bottom <= 0;
    var doc = document.documentElement;
    var nearBottom = (window.innerHeight + window.pageYOffset) >= (doc.scrollHeight - 140);
    stickyBar.classList.toggle('is-visible', scrolledPast && !nearBottom);
  }

  function bindStickyObserver() {
    if (!stickyBar || !stickyObserver) return;
    var btn = document.querySelector('.product-form__submit');
    if (btn && btn !== stickyObservedBtn) {
      if (stickyObservedBtn) stickyObserver.unobserve(stickyObservedBtn);
      stickyObserver.observe(btn);
      stickyObservedBtn = btn;
    }
    updateSticky();
  }

  function initStickyAtc() {
    if (document.querySelector('.lv-sticky-atc')) {
      stickyBar = document.querySelector('.lv-sticky-atc');
      bindStickyObserver();
      return;
    }
    if (!document.querySelector('.product-form__submit')) return;

    var bar = document.createElement('div');
    bar.className = 'lv-sticky-atc';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lv-sticky-atc__btn';
    btn.setAttribute('aria-label', 'Add to cart');
    btn.textContent = 'Add to cart';
    bar.appendChild(btn);
    document.body.appendChild(bar);
    stickyBar = bar;

    btn.addEventListener('click', scrollToBuySection);

    stickyObserver = new IntersectionObserver(function () { updateSticky(); }, { threshold: 0 });
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    bindStickyObserver();
  }

  function galleryScroller(gallery) {
    return gallery.querySelector('.product__media-list, ul.slider');
  }

  function initGalleryProgress() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.lv-gallery-progress')) return;
    var scroller = galleryScroller(gallery);
    if (!scroller) return;
    if (scroller.children.length < 2) return;
    var track = document.createElement('div');
    track.className = 'lv-gallery-progress';
    track.innerHTML = '<span class="lv-gallery-progress__bar"></span>';
    scroller.parentNode.insertBefore(track, scroller.nextSibling);
    var bar = track.firstChild;
    function visibleCount() {
      return Array.prototype.filter.call(scroller.children, function (c) {
        return c.style.display !== 'none';
      }).length || 1;
    }
    var lastKey = '';
    function upd() {
      var n = visibleCount();
      if (n < 2) { track.style.display = 'none'; lastKey = ''; return; }
      track.style.display = '';
      bar.style.width = (100 / n) + '%';
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var f = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
      if (f < 0) f = 0;
      if (f > 1) f = 1;
      var idx = Math.round(f * (n - 1));
      var key = n + ':' + idx;
      if (key === lastKey) return;
      lastKey = key;
      bar.style.transform = 'translateX(' + (idx * 100) + '%)';
    }
    scroller.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function wrapTitlePrice() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.lv-title-price')) return;
    var kids = Array.prototype.slice.call(info.children);
    var titleBlock = null, priceBlock = null;
    kids.forEach(function (k) {
      if (!titleBlock && (k.classList.contains('product__title') || k.querySelector('.product__title'))) { titleBlock = k; return; }
      if (!priceBlock && k.querySelector('.price')) priceBlock = k;
    });
    if (!titleBlock || !priceBlock || titleBlock === priceBlock) return;
    var row = document.createElement('div');
    row.className = 'lv-title-price';
    titleBlock.parentNode.insertBefore(row, titleBlock);
    row.appendChild(titleBlock);
    row.appendChild(priceBlock);
  }

  function readNativePrice() {
    var scope = document.querySelector('.lv-title-price') || document.querySelector('.product__info-container');
    if (!scope) return null;
    var block = scope.querySelector('.price');
    if (!block) return null;
    function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
    var onSale = block.classList.contains('price--on-sale') || !!block.querySelector('.price-item--sale');
    if (onSale) {
      var wasEl = block.querySelector('.price__sale .price-item--regular') ||
                  block.querySelector('s.price-item--regular') ||
                  block.querySelector('.price-item--regular');
      var nowEl = block.querySelector('.price-item--sale');
      return { was: txt(wasEl), now: txt(nowEl) };
    }
    var regEl = block.querySelector('.price__regular .price-item--regular') ||
                block.querySelector('.price-item--regular') ||
                block.querySelector('.price-item');
    return { was: '', now: txt(regEl) };
  }

  /* Price display. The admin Price is the FULL price. When this product has a
     config salePrice (its single-item deal price), show the admin price struck on
     the LEFT and the salePrice in red (+ a SALE badge via CSS). Otherwise fall back
     to the native behaviour: a real compare-at struck + the selling price, else the
     single price. The struck "was" is always the live admin price, so it auto-syncs. */
  function insertPdpPrice() {
    var row = document.querySelector('.lv-title-price');
    if (!row) return;
    var p = readNativePrice();
    if (!p || !p.now) return;
    var was = p.was, now = p.now;
    if (LV_CFG.salePrice) { was = now; now = LV_CFG.salePrice; }
    var html = '';
    if (was && was !== now) html += '<span class="lv-pdp-price__was">' + was + '</span>';
    html += '<span class="lv-pdp-price__now">' + now + '</span>';
    var el = row.querySelector('.lv-pdp-price');
    if (!el) { el = document.createElement('span'); el.className = 'lv-pdp-price'; row.appendChild(el); }
    if (el.dataset.lvHtml !== html) { el.innerHTML = html; el.dataset.lvHtml = html; }
  }

  var BOX_SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 8 12 3 3 8v8l9 5 9-5V8z"/>' +
      '<path d="M3 8l9 5 9-5"/>' +
      '<path d="M12 13v8"/>' +
    '</svg>';
  var LOCK_SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">' +
      '<path d="M6 10h1V7a5 5 0 0 1 10 0v3h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1zm3 0h6V7a3 3 0 0 0-6 0v3z"/>' +
      '<circle cx="12" cy="15" r="1.4" fill="#fff"/>' +
      '<rect x="11.35" y="15.2" width="1.3" height="2.6" rx="0.6" fill="#fff"/>' +
    '</svg>';
  var CHEVRON_SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var MINUS_SVG =
    '<svg class="lv-qtybox__ic lv-qtybox__ic--minus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>';
  var PLUS_SVG =
    '<svg class="lv-qtybox__ic lv-qtybox__ic--plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>';

  /* Simple promo text line above Add-to-cart (no box, no dropdown). */
  function insertOffer() {
    if (document.querySelector('.lv-offer')) return;
    var btn = document.querySelector('.product__info-container .product-form__submit') ||
              document.querySelector('.product-form__submit');
    if (!btn) return;
    var anchor = btn.closest('.product-form__buttons') || btn.closest('buy-buttons') || btn;
    var el = document.createElement('div');
    el.className = 'lv-offer';
    /* Wrap the $price part so it can be colored separately from the rest. */
    var text = lvEsc(LV_CFG.offer).replace(/(\$[0-9][0-9.,]*)/, '<span class="lv-offer__price">$1</span>');
    el.innerHTML = '<span class="lv-offer__title">' + text + '</span>';
    anchor.parentNode.insertBefore(el, anchor);
  }

  function lvEsc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Build the Size Chart modal markup from a product's sizeGuide config. */
  function buildSizeGuideHTML(cfg) {
    var sg = cfg.sizeGuide;
    var pct = (cfg.rating / 5) * 100;

    var headCells = sg.columns.map(function (c) { return '<th>' + lvEsc(c) + '</th>'; }).join('');
    var bodyRows = sg.rows.map(function (row) {
      var cells = row.map(function (cell, idx) {
        if (idx === 0) return '<th>' + lvEsc(cell) + '</th>';
        if (idx === 1) return '<td>' + lvEsc(cell) + '</td>';
        return '<td class="lv-sgx__m" data-in="' + lvEsc(cell) + '">' + lvEsc(cell) + '</td>';
      }).join('');
      return '<tr>' + cells + '</tr>';
    }).join('');

    var convRows = sg.rows.map(function (row) {
      return '<tr><th>' + lvEsc(row[0]) + '</th><td>' + lvEsc(row[1]) + '</td></tr>';
    }).join('');

    var bullets = (sg.bullets || []).map(function (b) {
      return '<li style="font-size:1.45rem;color:#11151c;line-height:1.5;margin:3px 0;">' + lvEsc(b) + '</li>';
    }).join('');

    return '' +
      '<div class="lv-sg__backdrop" data-lv-sg-close></div>' +
      '<div class="lv-sgx" role="dialog" aria-modal="true" aria-label="Size Chart">' +
        '<button type="button" class="lv-sgx__close" aria-label="Close" data-lv-sg-close>&times;</button>' +
        '<div class="lv-sgx__head">' +
          '<h2 class="lv-sgx__title">Size Chart</h2>' +
          '<div class="lv-sgx__headrow">' +
            '<div class="lv-sgx__meta">' +
              '<div class="lv-sgx__rating"><span class="lv-sgx__stars"><span class="lv-sgx__stars-e">★★★★★</span><span class="lv-sgx__stars-f" style="width:' + pct + '%">★★★★★</span></span><span class="lv-sgx__rcount">' + cfg.rating + ' (' + cfg.count + ' Reviews)</span></div>' +
              '<div class="lv-sgx__name">' + sg.fitLine + '</div>' +
              '<ul class="lv-sgx__fitlist" style="margin:10px 0 0;padding-left:18px;list-style:disc;">' + bullets + '</ul>' +
            '</div>' +
            '<div class="lv-sgx__thumb"></div>' +
          '</div>' +
        '</div>' +
        '<div class="lv-sgx__tabs">' +
          '<button type="button" class="lv-sgx__tab is-active" data-lv-tab="measure">Measurements</button>' +
          '<button type="button" class="lv-sgx__tab" data-lv-tab="convert">Size Conversion</button>' +
        '</div>' +
        '<div class="lv-sgx__scroll">' +
          '<div class="lv-sgx__panel" data-lv-panel="measure">' +
            '<div class="lv-sgx__secrow">' +
              '<span class="lv-sgx__sectitle">' + lvEsc(sg.title) + '</span>' +
              '<button type="button" class="lv-sgx__toggle" aria-label="Switch inches or centimeters">' +
                '<span class="lv-sgx__toglbl lv-sgx__toglbl--in is-on">IN</span>' +
                '<span class="lv-sgx__togsw"><span class="lv-sgx__togknob"></span></span>' +
                '<span class="lv-sgx__toglbl lv-sgx__toglbl--cm">CM</span>' +
              '</button>' +
            '</div>' +
            '<table class="lv-sgx__table">' +
              '<thead><tr>' + headCells + '</tr></thead>' +
              '<tbody>' + bodyRows + '</tbody>' +
            '</table>' +
          '</div>' +
          '<div class="lv-sgx__panel" data-lv-panel="convert" hidden>' +
            '<div class="lv-sgx__secrow"><span class="lv-sgx__sectitle">Size Conversion (US)</span></div>' +
            '<table class="lv-sgx__table">' +
              '<thead><tr><th>' + lvEsc(sg.columns[0]) + '</th><th>' + lvEsc(sg.columns[1]) + '</th></tr></thead>' +
              '<tbody>' + convRows + '</tbody>' +
            '</table>' +
          '</div>' +
          '<p class="lv-sgx__note">All measurements are approximate. Fits may vary by style or personal preference; sizes may vary by manufacturer.</p>' +
        '</div>' +
        '<div class="lv-sgx__foot"><p class="lv-sgx__contact">Still not sure what you need? <a href="/pages/contact-us">Contact us</a> to help you find the perfect size.</p></div>' +
      '</div>';
  }

  var SIZE_GUIDE_HTML = buildSizeGuideHTML(LV_CFG);

  function fillSizeGuide(el) {
    var nameEl = el.querySelector('.lv-sgx__name');
    if (nameEl && !nameEl.textContent) {
      var t = document.querySelector('.product__title');
      var name = '';
      if (t) (t.textContent || '').split('\n').forEach(function (s) { s = s.trim(); if (s && !name) name = s; });
      if (name) nameEl.textContent = name;
    }
    var thumb = el.querySelector('.lv-sgx__thumb');
    if (thumb) {
      var img = document.querySelector('media-gallery .product__media-item:not([style*="display: none"]) img') ||
                document.querySelector('media-gallery .product__media-item img') ||
                document.querySelector('.product__media img');
      var src = img && (img.currentSrc || img.src);
      if (src) {
        var existing = thumb.querySelector('img');
        if (existing) { if (existing.getAttribute('src') !== src) existing.src = src; }
        else { var i = document.createElement('img'); i.src = src; i.alt = ''; thumb.appendChild(i); }
      }
    }
  }

  function wireSizeGuide(el) {
    el.querySelectorAll('.lv-sgx__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-lv-tab');
        el.querySelectorAll('.lv-sgx__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        el.querySelectorAll('.lv-sgx__panel').forEach(function (p) { p.hidden = (p.getAttribute('data-lv-panel') !== key); });
      });
    });
    var toggle = el.querySelector('.lv-sgx__toggle');
    if (toggle) toggle.addEventListener('click', function () {
      var cm = toggle.classList.toggle('is-cm');
      el.querySelectorAll('.lv-sgx__toglbl--in').forEach(function (x) { x.classList.toggle('is-on', !cm); });
      el.querySelectorAll('.lv-sgx__toglbl--cm').forEach(function (x) { x.classList.toggle('is-on', cm); });
      el.querySelectorAll('.lv-sgx__u').forEach(function (u) { u.textContent = cm ? '(cm)' : '(in)'; });
      el.querySelectorAll('.lv-sgx__m').forEach(function (td) {
        var raw = td.getAttribute('data-in');
        td.textContent = cm ? raw.replace(/[0-9.]+/g, function (n) { return (parseFloat(n) * 2.54).toFixed(1); }) : raw;
      });
    });
  }

  function ensureSizeGuideModal() {
    var el = document.querySelector('.lv-sg');
    if (el) { fillSizeGuide(el); return el; }
    el = document.createElement('div');
    el.className = 'lv-sg';
    el.setAttribute('hidden', '');
    el.innerHTML = SIZE_GUIDE_HTML;
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-lv-sg-close]')) closeSizeGuide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSizeGuide();
    });
    wireSizeGuide(el);
    fillSizeGuide(el);
    return el;
  }
  function openSizeGuide() {
    var el = ensureSizeGuideModal();
    fillSizeGuide(el);
    el.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    var el = document.querySelector('.lv-sg');
    if (!el) return;
    el.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  function findSizeFieldset() {
    var sets = document.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var first = sets[i].querySelector('input[type=radio]');
      var optName = (first && first.getAttribute('data-option-name') || '').toLowerCase();
      var legend = sets[i].querySelector('legend');
      var legendText = legend ? legend.textContent.trim().replace(/\s.*$/, '').toLowerCase() : '';
      if (optName === 'size' || legendText === 'size') return sets[i];
    }
    return null;
  }

  var sizePicked = false;
  var lvQty = 1;
  var lvQtyBound = false;

  function bindQtySubmit() {
    if (lvQtyBound) return;
    lvQtyBound = true;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      var inp = f.querySelector('input[name="quantity"]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'quantity'; inp.className = 'lv-qty-hidden';
        f.appendChild(inp);
      }
      inp.value = lvQty;
    }, true);
  }

  function optValue(inp) { return (inp && inp.value || '').trim(); }

  function isSizeSoldOut(fs, inp) {
    if (inp.disabled || inp.classList.contains('disabled')) return true;
    var lbl = fs.querySelector('label[for="' + inp.id + '"]');
    return !!(lbl && lbl.classList.contains('disabled'));
  }

  function updateSizeField() {
    var fs = findSizeFieldset();
    var field = document.querySelector('.lv-size');
    var val = document.querySelector('.lv-size__value');
    if (!fs || !val) return;
    var checked = fs.querySelector('input[type=radio]:checked');
    var text = (sizePicked && checked) ? (optValue(checked) || 'Size') : 'Size';
    var selected = !!(sizePicked && checked);
    if (val.textContent !== text) val.textContent = text;
    if (field) field.classList.toggle('is-selected', selected);
  }

  function selectSize(inp) {
    if (inp && !inp.checked) {
      inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      inp.dispatchEvent(new Event('input', { bubbles: true }));
    }
    sizePicked = true;
    updateSizeField();
  }

  function ensureSizeSheet() {
    var el = document.querySelector('.lv-size-sheet');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'lv-size-sheet';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="lv-size-sheet__backdrop" data-lv-sheet-close></div>' +
      '<div class="lv-size-sheet__panel" role="dialog" aria-modal="true" aria-label="Pick a Size">' +
        '<div class="lv-size-sheet__head">' +
          '<span class="lv-size-sheet__title">Pick a Size</span>' +
          '<button type="button" class="lv-size-sheet__close" aria-label="Close" data-lv-sheet-close>&times;</button>' +
        '</div>' +
        '<ul class="lv-size-sheet__list"></ul>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target.closest('[data-lv-sheet-close]')) closeSizeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizeSheet(); });
    document.addEventListener('click', function (e) {
      var s = document.querySelector('.lv-size-sheet');
      if (!s || s.hasAttribute('hidden')) return;
      var panel = s.querySelector('.lv-size-sheet__panel');
      var field = document.querySelector('.lv-size');
      if (panel && panel.contains(e.target)) return;
      if (field && field.contains(e.target)) return;
      closeSizeSheet();
    }, true);
    return el;
  }

  function positionSizeDrop(sheet) {
    var field = document.querySelector('.lv-size');
    var panel = sheet.querySelector('.lv-size-sheet__panel');
    if (!field || !panel) return;
    var r = field.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.left = r.left + 'px';
    panel.style.top = (r.bottom + 4) + 'px';
    panel.style.width = r.width + 'px';
  }

  function openSizeSheet() {
    var fs = findSizeFieldset();
    if (!fs) return;
    var sheet = ensureSizeSheet();
    var list = sheet.querySelector('.lv-size-sheet__list');
    list.innerHTML = '';
    fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
      var soldOut = isSizeSoldOut(fs, inp);
      var li = document.createElement('li');
      li.className = 'lv-size-sheet__item' + (inp.checked && sizePicked ? ' is-selected' : '') + (soldOut ? ' is-soldout' : '');
      li.textContent = optValue(inp);
      if (!soldOut) li.addEventListener('click', function () { selectSize(inp); closeSizeSheet(); });
      list.appendChild(li);
    });
    var field = document.querySelector('.lv-size');
    if (field) field.classList.add('is-open');
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    sheet.classList.toggle('is-drop', desktop);
    sheet.removeAttribute('hidden');
    if (desktop) {
      positionSizeDrop(sheet);
      if (!sheet.dataset.lvRepos) {
        sheet.dataset.lvRepos = '1';
        var repos = function () { if (!sheet.hasAttribute('hidden')) positionSizeDrop(sheet); };
        window.addEventListener('scroll', repos, true);
        window.addEventListener('resize', repos);
      }
    } else {
      document.documentElement.style.overflow = 'hidden';
    }
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
  }

  function closeSizeSheet() {
    var sheet = document.querySelector('.lv-size-sheet');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('hidden', '');
    sheet.classList.remove('is-drop');
    var field = document.querySelector('.lv-size');
    if (field) field.classList.remove('is-open');
    var panel = sheet.querySelector('.lv-size-sheet__panel');
    if (panel) { panel.style.position = ''; panel.style.left = ''; panel.style.top = ''; panel.style.width = ''; }
    document.documentElement.style.overflow = '';
  }

  function currentQtyInput() {
    return document.querySelector('.product__info-container form[action*="/cart/add"] input[name="quantity"]') ||
           document.querySelector('.product__info-container product-form input[name="quantity"]') ||
           document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
  }
  function ensureQtyInput() {
    var input = currentQtyInput();
    if (input) return input;
    var form = document.querySelector('.product__info-container form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    input = document.createElement('input');
    input.type = 'hidden'; input.name = 'quantity'; input.value = '1'; input.className = 'lv-qty-hidden';
    form.appendChild(input);
    return input;
  }

  function buildSizeQtyRow() {
    var fs = findSizeFieldset();
    if (!fs) return;
    fs.classList.add('lv-size-native');
    var qi = currentQtyInput();
    if (qi) {
      var nq = qi.closest('.product-form__quantity, quantity-input, .product-form__input--quantity');
      if (nq) nq.classList.add('lv-qty-native');
    }
    if (document.querySelector('.lv-size-row')) { updateSizeField(); return; }

    var row = document.createElement('div');
    row.className = 'lv-size-row';

    var field = document.createElement('button');
    field.type = 'button';
    field.className = 'lv-size';
    field.setAttribute('aria-haspopup', 'dialog');
    field.innerHTML =
      '<span class="lv-size__value">Size</span>' +
      '<span class="lv-size__caret">' + CHEVRON_SVG + '</span>';
    field.addEventListener('click', function (e) {
      e.preventDefault();
      var sheet = document.querySelector('.lv-size-sheet');
      if (sheet && !sheet.hasAttribute('hidden')) { closeSizeSheet(); } else { openSizeSheet(); }
    });

    var qty = document.createElement('div');
    qty.className = 'lv-qtybox';
    qty.innerHTML =
      '<button type="button" class="lv-qtybox__btn" data-lv-qty="-1" aria-label="Decrease quantity">' + MINUS_SVG + '</button>' +
      '<span class="lv-qtybox__val">' + lvQty + '</span>' +
      '<button type="button" class="lv-qtybox__btn" data-lv-qty="1" aria-label="Increase quantity">' + PLUS_SVG + '</button>';
    var valEl = qty.querySelector('.lv-qtybox__val');
    var minusBtn = qty.querySelector('[data-lv-qty="-1"]');
    var plusBtn = qty.querySelector('[data-lv-qty="1"]');
    function syncQty(v) {
      v = Math.max(1, Math.min(10, v || 1));
      valEl.textContent = v;
      lvQty = v;
      var inp = ensureQtyInput();
      if (inp) { inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      minusBtn.disabled = (v <= 1);
      plusBtn.disabled = (v >= 10);
    }
    syncQty(lvQty);
    qty.querySelectorAll('.lv-qtybox__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = parseInt(valEl.textContent, 10) || 1;
        syncQty(cur + parseInt(b.getAttribute('data-lv-qty'), 10));
      });
    });

    row.appendChild(field);
    row.appendChild(qty);
    fs.insertAdjacentElement('afterend', row);

    updateSizeField();
    fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
      inp.addEventListener('change', updateSizeField);
    });
  }

  function initSizeDetailsLink() {
    var row = document.querySelector('.lv-size-row');
    if (!row || document.querySelector('.lv-sg__trigger')) return;
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'lv-sg__trigger';
    trigger.textContent = 'Size Details';
    trigger.addEventListener('click', function (e) { e.preventDefault(); openSizeGuide(); });
    row.parentNode.insertBefore(trigger, row);
    ensureSizeGuideModal();
  }

  /* Color name -> swatch hex. Match is case-insensitive on the option value. */
  var COLOR_MAP = {
    'white':         '#f5eae2',
    'gray beige':    '#c9b9b2',
    'grey beige':    '#c9b9b2',
    'autumn amber':  '#a96847',
    'mist green':    '#b5b791',
    'haze blue':     '#5e6990',
    'quality grey':  '#d0cbbf',
    'quality khaki': '#d4c0ae',
    'red':           '#b10732',
    'orange':        '#cd5440',
    'caramel':       '#81451e',
    'brown':         '#9e4f2a',
    'green':         '#386523',
    'khaki':         '#d4c0ae',
    'wine red':      '#781b1a',
    'black':         '#141414'
  };
  var SW_RING = '#11151c';
  var SW_DOT = 26;
  var SW_LABEL = 26;
  var SW_RINGS = '0 0 0 2px #fff, 0 0 0 3px ' + SW_RING;
  var bodyObserver = null;
  var piObserver = null;
  var piRunning = false;

  function withObserverPaused(fn) {
    if (bodyObserver) bodyObserver.disconnect();
    try { fn(); } finally {
      if (bodyObserver) {
        bodyObserver.takeRecords();
        bodyObserver.observe(document.body, { childList: true, subtree: true });
      }
    }
  }

  function getLabelText(el) {
    var t = '';
    el.childNodes.forEach(function (n) { if (n.nodeType === Node.TEXT_NODE) t += n.textContent; });
    return t.trim();
  }

  function findColorFieldset() {
    var sets = document.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      var first = sets[i].querySelector('input[type=radio]');
      var optName = (first && first.getAttribute('data-option-name') || '').toLowerCase();
      var legendText = legend ? legend.textContent.trim().replace(/\s.*$/, '').toLowerCase() : '';
      if (optName === 'color' || legendText === 'color') return sets[i];
    }
    return null;
  }

  function updateColorLegend(fieldset) {
    var legend = fieldset.querySelector('legend');
    var checked = fieldset.querySelector('input[type=radio]:checked');
    if (!legend || !checked) return;
    if (legend.dataset.lvVal === checked.value) return;
    legend.dataset.lvVal = checked.value;
    legend.innerHTML = 'Color <span style="font-weight:400;margin-left:10px;opacity:0.85">' + checked.value + '</span>';
  }

  function updateSwatchRings(fieldset) {
    fieldset.querySelectorAll('input[type=radio]').forEach(function (inp) {
      var lbl = fieldset.querySelector('label[for="' + inp.id + '"]');
      if (!lbl || !lbl.classList.contains('lv-color-sw')) return;
      var next = inp.checked ? SW_RINGS : 'none';
      if (lbl.style.boxShadow !== next) lbl.style.boxShadow = next;
    });
  }

  function buildColorSwatches() {
    var fieldset = findColorFieldset();
    if (!fieldset) return;
    withObserverPaused(function () {
      if (fieldset.dataset.lvSwatched === '1') {
        updateColorLegend(fieldset);
        updateSwatchRings(fieldset);
        return;
      }
      fieldset.querySelectorAll('label').forEach(function (label) {
        var name = getLabelText(label);
        var hex = COLOR_MAP[name.toLowerCase()];
        if (!hex) return;
        var input = document.getElementById(label.getAttribute('for'));
        var soldOut = !!(input && input.classList.contains('disabled'));
        label.childNodes.forEach(function (n) { if (n.nodeType === Node.TEXT_NODE) n.textContent = ''; });
        var hidden = label.querySelector('.visually-hidden');
        if (hidden) hidden.remove();
        var dot = document.createElement('span');
        dot.style.cssText = [
          'display:block','width:' + SW_DOT + 'px','height:' + SW_DOT + 'px','border-radius:50%',
          'background:' + hex,'border:1px solid #a8a8a8','box-shadow:none','pointer-events:none'
        ].join(';');
        label.insertBefore(dot, label.firstChild);
        if (soldOut) {
          var strike = document.createElement('span');
          strike.style.cssText = [
            'position:absolute','top:50%','left:50%',
            'width:' + (SW_DOT + 6) + 'px','height:2px',
            'background:#fff','box-shadow:0 0 0 1px rgba(0,0,0,0.4)',
            'transform:translate(-50%,-50%) rotate(-45deg)','pointer-events:none'
          ].join(';');
          label.appendChild(strike);
          label.title = name + ' — Sold out';
        }
        label.classList.add('lv-color-sw');
        label.style.cssText = [
          'position:relative','display:inline-flex','align-items:center','justify-content:center',
          'width:' + SW_LABEL + 'px','height:' + SW_LABEL + 'px','border-radius:50%',
          'padding:0','border:none','background:transparent','cursor:pointer',
          'box-sizing:border-box','transition:box-shadow 0.15s','margin:6px'
        ].join(';');
      });
      fieldset.dataset.lvSwatched = '1';
      fieldset.style.cssText = 'display:flex;align-items:center;flex-wrap:wrap;padding:0;border:none;margin:0;';
      updateColorLegend(fieldset);
      updateSwatchRings(fieldset);
      fieldset.querySelectorAll('input[type=radio]').forEach(function (inp) {
        inp.addEventListener('change', function () { updateColorLegend(fieldset); updateSwatchRings(fieldset); filterGalleryByColor(); });
      });
    });
  }

  /* Show the selected color's image set. Two different galleries per viewport:
     - MOBILE (<750px): a swipe slider. display:none the other colors so only this
       set is swipeable (the original, working behavior). Do NOT change this.
     - DESKTOP (>=750px): a one-at-a-time slideshow. display:none-ing the main
       slides leaves no active slide and the big photo collapses, so instead keep
       the main slides in place, filter only the thumbnail strip, and drive the
       theme's own setActiveMedia() to this color's first image. */
  function filterGalleryByColor() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var fs = findColorFieldset();
    var checked = fs && fs.querySelector('input[type=radio]:checked');
    if (!checked) return;
    var colorVal = (checked.value || '').toLowerCase().trim();
    if (!colorVal) return;
    var words = colorVal.split(/\s+/);

    var otherWords = {};
    fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
      var v = (inp.value || '').toLowerCase().trim();
      if (!v || v === colorVal) return;
      v.split(/\s+/).forEach(function (w) { otherWords[w] = true; });
    });
    var distinctive = words.filter(function (w) { return !otherWords[w]; });

    var items = gallery.querySelectorAll('.product__media-item');
    if (!items.length) return;

    function matches(el) {
      var img = el.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '').toLowerCase().trim() : '';
      if (!alt) return false;
      return alt === colorVal || distinctive.indexOf(alt) !== -1;
    }

    var matchCount = 0, firstMatch = null;
    items.forEach(function (it) { if (matches(it)) { matchCount++; if (!firstMatch) firstMatch = it; } });

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    var scroller = galleryScroller(gallery);
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    var key = (matchCount === 0) ? '__all__' : (colorVal + '|' + (isDesktop ? 'd' : 'm'));

    if (matchCount === 0) {
      if (gallery.getAttribute('data-lv-color') === '__all__') return;
      items.forEach(function (it) { it.style.display = ''; });
      thumbs.forEach(function (t) { t.style.display = ''; });
      gallery.setAttribute('data-lv-color', '__all__');
      if (scroller) scroller.dispatchEvent(new Event('scroll'));
      return;
    }

    if (gallery.getAttribute('data-lv-color') === key) return;
    gallery.setAttribute('data-lv-color', key);

    /* Thumbnail strip: only this color's thumbnails (both viewports). */
    thumbs.forEach(function (t) { t.style.display = matches(t) ? '' : 'none'; });

    if (isDesktop) {
      /* Desktop slideshow: never display:none the main slides. Clear any leftover
         hiding (e.g. from a prior mobile state) and hand the color's first image
         to the theme's own gallery API so the big main photo renders. */
      items.forEach(function (it) { it.style.display = ''; });
      var mediaId = firstMatch.getAttribute('data-media-id');
      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        var apply = function () { try { gallery.setActiveMedia(mediaId, true); } catch (e) {} };
        apply();
        requestAnimationFrame(apply);
      }
      return;
    }

    /* Mobile swipe slider: hide the other colors so only this set swipes. */
    var firstVisible = null;
    items.forEach(function (it) {
      var ok = matches(it);
      it.style.display = ok ? '' : 'none';
      if (ok && !firstVisible) firstVisible = it;
    });
    if (scroller && firstVisible) {
      scroller.scrollLeft = Math.max(0, firstVisible.offsetLeft - scroller.offsetLeft);
      scroller.dispatchEvent(new Event('scroll'));
    }
  }

  function replaceTrustIcons() {
    var native = document.querySelector('.product__info-container .icon-with-text');
    if (!native) return;
    if (document.querySelector('.lv-trust-list')) return;
    var list = document.createElement('ul');
    list.className = 'lv-trust-list';
    list.innerHTML =
      '<li>' + BOX_SVG + '<span>Free Premium Shipping</span></li>' +
      '<li>' + LOCK_SVG + '<span>Secure payment</span></li>';
    native.insertAdjacentElement('afterend', list);
    native.classList.add('lv-trust-hidden');
  }

  function initDynamic() {
    insertBreadcrumb();
    wrapTitlePrice();
    insertPdpPrice();
    insertRatingBadge();
    buildColorSwatches();
    initGalleryProgress();
    filterGalleryByColor();
    replaceTrustIcons();
    buildSizeQtyRow();
    initSizeDetailsLink();
    insertOffer();
    bindStickyObserver();
    attachProductInfoObserver();
  }

  var dynScheduled = false;
  function scheduleDynamic() {
    if (dynScheduled) return;
    dynScheduled = true;
    requestAnimationFrame(function () { dynScheduled = false; initDynamic(); });
  }

  /* Flash killer: product-info-scoped synchronous rebuild (pre-paint). */
  function rebuildNow() {
    if (piRunning) return;
    piRunning = true;
    if (piObserver) piObserver.disconnect();
    try { initDynamic(); }
    finally {
      var pi = document.querySelector('product-info');
      if (piObserver && pi) { piObserver.takeRecords(); piObserver.observe(pi, { childList: true, subtree: true }); }
      piRunning = false;
    }
  }

  function attachProductInfoObserver() {
    var pi = document.querySelector('product-info');
    if (!pi || pi.dataset.lvPi === '1') return;
    pi.dataset.lvPi = '1';
    if (!piObserver) piObserver = new MutationObserver(rebuildNow);
    piObserver.observe(pi, { childList: true, subtree: true });
  }

  function initColorSwatches() {
    if (document.body.dataset.lvBodyObserved !== '1') {
      document.body.dataset.lvBodyObserved = '1';
      bodyObserver = new MutationObserver(scheduleDynamic);
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
    initDynamic();
  }

  function init() {
    initStickyAtc();
    initColorSwatches();
    bindQtySubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
